import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import FaqAccordion from "@/components/FaqAccordion";
import { FadeUp } from "@/components/Reveal";
import { FAQ_ITEMS } from "@/data/faq";
import { EMAILS } from "@/config";

export default function FaqPage() {
  return (
    <>
      <PageHeader silk={2}
        testid="faq-header"
        eyebrow="SSS"
        titleLines={["Sıkça sorulan", "sorular."]}
        lede="Five Star, The Five, My Date, üyelik ve gizlilik hakkında merak edilenler."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto">
          <FaqAccordion items={FAQ_ITEMS} />
          <FadeUp delay={0.15} className="mt-12 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 text-sm">
            <span className="text-ink-muted">Yanıtını bulamadın mı?</span>
            <div className="flex flex-wrap gap-x-8 gap-y-3">
              <Link to="/account-deletion" data-testid="faq-deletion-link" className="link-ghost !text-[13px]">
                Hesap Silme
              </Link>
              <Link to="/privacy" data-testid="faq-privacy-link" className="link-ghost !text-[13px]">
                Gizlilik Politikası
              </Link>
              <a href={`mailto:${EMAILS.support}`} data-testid="faq-support-mailto" className="link-ghost !text-[13px]">
                Destek Ekibine Yaz
              </a>
            </div>
          </FadeUp>
        </div>
      </section>
    </>
  );
}
